import { useTranslation } from 'next-i18next'

export function GYGAdNotice() {
  const { t } = useTranslation('common')
  return (
    <div className="ml-2 text-xs xs:text-sm text-neutral">{t('gyg-ad')}</div>
  )
}
